export const END_POINTS = {
  DASHBOARD: {
    /****DASHBOARD*******/
    getUsers: '/dashboard/users',
    getFacilityList: '/api/user/facility',
    getFacilities: '/api/user/facilities',
    getScenarios: `/api/user/scenarios`,
    getCompareShiftMapData: (facilityCode: string) =>
      `/api/graph/shift_map/${facilityCode}`,
    getScenarioDetailData: (scenario: string) =>
      `/api/graph/shift_detail/${scenario}`,
    getShiftCascadeData: (scenario: string) =>
      `/api/graph/shift_cascade/${scenario}`,
    geToleranceData: (scenario: string) => `/api/graph/tolerance/${scenario}`,
    getPtsArrivalsPtsCovered: (scenario: string) =>
      `/api/graph/patientarrivals_patientcovered/${scenario}`,
    geDowVolumesData: (scenario: string) => `/api/graph/dow_volume/${scenario}`,
    getAllShifts: (scenario: string) => `/api/graph/shift_data/${scenario}`,
    updateShifts: `/api/graph/shift_data`,
    resetShifts: `/api/graph/shift_data/reset`,

    /*******************/
  },
  SOT: {
    /********SOT**********/
    getUserParams: (facilityCode: string) =>
      `/api/graph/cube_data/${facilityCode}`,
    generateShiftSync: `/api/sot/generate_shift_sync`,
    generateShiftAsync: `/api/sot/generate_shift_async`,
    forcedShifts: (facilityCode: string) =>
      `/api/graph/forced_shift/${facilityCode}`,
    versions: `/api/user/versions`,
    addNewVersion: `/api/user/versions/new`,
    updateParamVersion: `/api/user/versions/update`,
    deleteParamVersion: `/api/user/versions/delete`,
    /************************/
  },
  WEB_SOCKET: {
    /********************************** */
    taskStatus: (id: string) => `/ws/task_status/${id}`,
    socketIo: `/ws/sot`,
    /********************************* */
  },
};
